export const getWalkingDirectionsPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/routing/walking-directions`;
